import React, { useState } from "react";
import Education from "../about/Education";
import EducationEn from "../about/English/Education";
import Industries from "./Industries";
import IndustriesEn from "./IndustriesEn";
import References from "./References";
import ReferencesEn from "./ReferencesEn";
import { useLanguage } from "../../context/LanguageContext"; // vagy a megfelelő elérési út


const Services = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <section className="main-content">
      <div className="container">

        {/* Experience & Education Starts */}
        <div className="resume-box">
          {language === "hu" ? <Education key="hu-education" /> : <EducationEn key="en-education" />}
        </div>
        {/* Experience & Education Ends */}

        <hr className="separator" />

        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase mb-sm-0 text-left text-sm-center custom-title ft-wt-600">
              {language === "hu" ? "Iparágak" : "Industries"}
            </h3>
            {language === "hu" ? <Industries key="hu-industries" /> : <IndustriesEn key="en-industries" />}
          </div>
        </div>

        <hr className="separator" />

        <div className="row">
          <div className="col-12">
            <h3 className="text-uppercase mb-sm-0 text-left text-sm-center custom-title ft-wt-600">
              {language === "hu" ? "Referenciák" : "References"}
            </h3>
            {language === "hu" ? <References key="hu-references" /> : <ReferencesEn key="en-references" />}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;